import { makeStyles, styled } from "@material-ui/core";
import { Column, Columns, Flex, Input, div } from "lqx-react";
import React from "react";
import Select from "react-select";
import { AssetType } from "../../api/assetType";
import { getCompanies } from "../../api/company";
import { ValidationRuleDetails } from "../../api/validationRuleDetails";
import { DigitizationSelect } from "../../components/select";
import {
  CancelButton, ConfirmationButton,
  ErrorHighlighter, RightAlignedButtons,
  StartOverButton, WorkflowBody, WorkflowFooter, WorkflowTitle
} from "../../shared";
import { globalStore } from "api/store";

export const ValidationRuleDetailsStep = ({ next, cancel, startOver, validationRuleDetails }
  : { next?, cancel?, startOver?, validationRuleDetails?: ValidationRuleDetails }) => {
    const assetTypeOptionSingle = globalStore.assetTypesLookup.items.models;
  const isEdit = () => validationRuleDetails.id;
  const getNextButtonText = () => 'Next: Validation Set';

  return (
    <>
      <WorkflowTitleStyled>
        Step 1: Name your Validation and fill out additional details
      </WorkflowTitleStyled>
      <ModelDetailsContainer>
        <WorkflowBody>
          <WorkflowTitleStyled>
            Create a name for your validation
          </WorkflowTitleStyled>
          <Section column>
            <FilterLabel>Validation Name</FilterLabel>
            <Flex row>
              <Flex column>
                <ErrorHighlighter classes={makeErrorHighlighterStyles()}>
                  <Input $value={validationRuleDetails.$.name} placeholder="Validation Name" aria-label="Validation Name" />
                </ErrorHighlighter>
              </Flex>
            </Flex>
          </Section>
          <Flex column>
            <WorkflowTitleWrapper>
              <WorkflowTitleStyled>
                Select the Asset type for your Validation
              </WorkflowTitleStyled>
            </WorkflowTitleWrapper>
          </Flex>
          <Section row>
            <DropdownBox>
              <FilterLabel>Asset Type</FilterLabel>
              <ErrorHighlighter>
                <Select
                  aria-label="Asset Type"
                  isMulti={false}
                  placeholder={'Asset Type'}
                  styles={customStyles}
                  value={assetTypeOptionSingle.filter(function (option) {
                    return option.id === validationRuleDetails.$.assetTypeId.value;
                  })}
                  isDisabled={false}
                  getOptionValue={(e: any) => e.id}
                  getOptionLabel={(e: any) => e.name}
                  isOptionDisabled={(e: any) => e.disabled}
                  options={assetTypeOptionSingle}
                  onChange={(value: any) => {
                    validationRuleDetails.$.assetTypeId.set(value.id);
                    validationRuleDetails.ruleSets.set([]);
                  }}
                />
              </ErrorHighlighter>
            </DropdownBox>
          </Section>
          <Flex row>
            <WorkflowTitleWrapper>
              <WorkflowTitleStyled>
                Select the Companies that can use this Validation
              </WorkflowTitleStyled>
            </WorkflowTitleWrapper>
          </Flex>
          <Section row>
            <DropdownBox>
              <FilterLabel>Companies</FilterLabel>
              <ErrorHighlighter>
                <DigitizationSelect
                  aria-label="Companies"
                  placeholder={'Companies'}
                  $value={validationRuleDetails.$.companies}
                  getItems={getCompanies}
                  isMulti
                />
              </ErrorHighlighter>
            </DropdownBox>
          </Section>
        </WorkflowBody>
      </ModelDetailsContainer>
      <WorkflowFooter>
        <Columns>
          <Column>
            <Flex row>
              <CancelButton color="primary" onClick={cancel}>Cancel</CancelButton>
              {isEdit() ? <></> : <StartOverButton color="primary" onClick={startOver}>Start Over</StartOverButton>}
            </Flex>
          </Column>
          <Column>
            <RightAlignedButtons>
              <ConfirmationButton disabled={!validationRuleDetails.isValid() || validationRuleDetails.companies.length <= 0} onClick={() => next({id: validationRuleDetails.id, name: validationRuleDetails.name, assetTypeId: validationRuleDetails.assetTypeId})}>{getNextButtonText()}</ConfirmationButton>
            </RightAlignedButtons>
          </Column>
        </Columns>
      </WorkflowFooter>
    </>
  );
};

const makeErrorHighlighterStyles = makeStyles({
  root: {
    '& [class*="-error-"]': {
      border: '1px solid #FF274B !important',
      borderRadius: '1px'
    }
  },
});

const DropdownBox = styled(Column)({
  marginLeft: 0,
  marginRight: 0,
});

const FilterLabel = div({
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  padding: '4px',
  marginTop: '5px',
  color: 'grey'
});

const ModelDetailsContainer = div({
  background: '#FFFFFF',
  border: '1px solid #E2F0F7',
  borderRadius: '4px',
  padding: '30px',
  marginBottom: '50px',
  display: 'flex',
  justifyContent: 'space-between'
});

const Section = styled(Flex)({
  paddingLeft: '30px',
  display: 'flex',
  flexDirection: 'column',
})

const WorkflowTitleWrapper = styled('div')({
  margin: '30px 0 0 0'
})

const WorkflowTitleStyled = styled(WorkflowTitle)({
  height: 30,
  fontSize: '14px',
})

const customStyles = {
  container: provided => ({
    ...provided,
    width: '100%'
  }),
  control: provided => ({
    ...provided,
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E3E9ED'
  }),
  valueContainer: (provided) => ({
    ...provided,
    width: 'auto',
    overflowX: 'hidden',
    overflowY: 'hidden',
    fontSize: 14,
    fontWeight: 500,
  }),
  indicatorSeparator: provided => ({
    display: 'none'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'rgba(0, 0, 0, 0.54)',
    marginRight: 0,
    padding: 0
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999, marginTop: 0 })
}